import { CheckIcon, PencilIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';

const Drivers = ({ branchColour, scheduleLimit, updateSchedule, max }) => {
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(scheduleLimit);

  const save = (e) => {
    e.preventDefault();
    setEdit(false);
    updateSchedule(value);
  };

  return (
    <div className="flex items-center rounded-md md:items-stretch">
      {!edit ? (
        <>
          <span>Drivers available: {scheduleLimit}</span>
          <button
            className={`ml-2 text-gray-200`}
            style={{
              transition: 'color 0.3s',
            }}
            onMouseEnter={(e) =>
              ((e.target as HTMLDivElement).style.color = branchColour)
            }
            onMouseLeave={(e) =>
              ((e.target as HTMLDivElement).style.color = 'gray')
            }
            onClick={() => setEdit(true)}
          >
            <PencilIcon className="h-6" />
          </button>
        </>
      ) : (
        <form onSubmit={save} className="flex items-center">
          <input
            className="w-full rounded-md border border-gray-200 p-2"
            type="number"
            min={0}
            max={max}
            value={value}
            onChange={(e) => setValue(parseInt(e.target.value))}
            required
          />
          <button
            className={`ml-2 h-6`}
            style={{
              accentColor: branchColour,
              outline: `2px solid ${branchColour}`,
            }}
          >
            <CheckIcon className="h-6" />
          </button>
        </form>
      )}
    </div>
  );
};

export default Drivers;
